import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import React, { useState, useRef } from 'react';
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import useAuthAxios from "../../../useAuthAxios";
import LoadingDialog from '../../Loading';

import {
    NomalButton,
} from '../../css/CSS.js';

export default function UploadButtons(props) {
    const { control } = useForm({
        defaultValues: {
            attachFileData: "",
            attachFileName: "",
        },
    });


    const authAxios = useAuthAxios();
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [activePost, setactivePost] = useState(false);
    const headers = { "Authorization": "Bearer " + localStorage.getItem("Auth"), 'Content-Type': 'multipart/form-data' };
    const navigate = useNavigate();
    const [processing, setProcessing] = useState(false);
    const inputPostFileRef = useRef(null);
    const [inputKey, setInputKey] = useState(0);

    const namePlateExts = ['jpg', 'jpeg', 'heic']
    const handleFileInputChange = ({ target }) => {
        if (target.files < 1 || !target.validity.valid) {
            return;
        }

        if (!namePlateExts.includes(target.files[0].name.split('.').pop().toLowerCase())) {
            setInputKey((prevKey) => prevKey + 1);
            alert("jpg/jpeg、heicのいずれかのファイルを選択して下さい。")
            return;
        }
        let fileNameLengthCounter = 0;
        for (let i = 0; i < target.files[0].name.length; i++) {
            if (target.files[0].name[i].match(/^[^ -~｡-ﾟ]/)) {
                fileNameLengthCounter += 2
            } else {
                fileNameLengthCounter += 1
            }
            if (fileNameLengthCounter > 60) {
                alert("ファイル名は半角60文字、全角30文字以内に指定してください。")
                setInputKey((prevKey) => prevKey + 1);
                return
            }
        }
        setFile(target.files[0]);
        setInputKey((prevKey) => prevKey + 1);
        setFileName(target.files[0].name);
        setactivePost(true);
    };

    const onSubmit = () => {
        if (file != null) {
            setactivePost(true);
        }
    };

    React.useEffect(() => {
        if (processing === true) { return }

        if (activePost === true) {
            setProcessing(true);
            const body = new FormData();
            body.append("fileName", fileName);
            body.append("file", file);
            authAxios
                .post('api/visitReport'
                    + "/" + props.keyData.kojiCD
                    + "/" + props.keyData.rptShubetsu
                    + "/" + props.keyData.rptSeq
                    + '/PosFile'
                    , body
                    , { headers })
                .then(response => {
                    if (response.status === 200) {
                        setactivePost(false);
                        setProcessing(false);
                        props.setPosStatus(true);
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        alert("認証情報が正しくありません。");
                        navigate("/");
                    } else {
                        alert("ファイル登録に失敗しました。");
                        setactivePost(false);
                    }
                    setProcessing(false);
                });
        }
    }, [activePost]);



    const PostFileUpload = () => {
        inputPostFileRef.current.click();
    }

    return (
        <label htmlFor="contained-button-file">
            <LoadingDialog load={processing} />
            <form onSubmit={onSubmit} >
                <Controller
                    control={control}
                    name="attachmentFile"
                    render={({ field }) => (
                        <FileUploadButton
                            {...field}
                            className="primary"
                            name="inspectionFiles"
                            inputKey={inputKey}
                            ref={inputPostFileRef}
                            onChange={handleFileInputChange}
                            onClick={PostFileUpload}
                            sx={{ boxShadow: 0, }}
                            keyData={props?.keyData}
                        />
                    )}
                />
            </form>
        </label>
    );
}


export const FileUploadButton = React.forwardRef((props, ref) => {
    return (
        <label htmlFor={`upload-button-${props.name}`}>
            <input
                accept=".jpg,.jpeg,.heic"
                id={`upload-button-${props.name}`}
                name={props.name}
                multiple
                key={props.inputKey}
                type="file"
                ref={ref}
                onChange={props.onChange}
                disabled={props?.keyData?.status === 4 || !props?.keyData?.canEdit ? true : false}
                hidden
            />
            <NomalButton
                variant="contained"
                size="large"
                {...props}
                sx={{ ml: 2, mr: 2, pt: 1.5, pb: 1.5, pl: 4, pr: 4, fontSize: '18px' }}
                onClick={props.onClick}
                disabled={props?.keyData?.status === 4 || !props?.keyData?.canEdit ? true : false}
            >
                {props.children}
                <AddPhotoAlternateIcon sx={{ mr: 2, fontSize: '2rem' }} />
                ファイル選択
            </NomalButton>
        </label>
    );
});

